<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import DehumidifierModeV2 from './DehumidifierModeV2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { devices_config } from '@devices/index';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getGen1DeviceStatuses, createGen1StatusLabels } from '../../../Gen1/gen1-main-helpers';
	import { real_id } from 'src/helpers/interface_helpers';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
	let mode: string;
	const _device = device;
	$: enable = statuses.find((i) => /^(enable)$/.test(i.role));
</script>

<DeviceNotificationLabel deviceId={device?.id} />
<div class="flex-full-height justify-content-end">
	<div class="mb-s">
		<DehumidifierModeV2 {device} {statuses} bind:mode />
	</div>
	<ControlsContainer class="mt-s" color="color-0">
		<svelte:fragment slot="first">
			<VirtualBooleanButton
				isWide
				device={_device}
				componentID={enable?.id}
				value={enable?.event}
				useV2Components
			/>
			<Text styleType="controls-large" class="mt-s text-bold"
				>{capFirstChar(
					enable?.event
						? $format('label_action_turn_off', { default: 'turn off' })
						: $format('label_action_turn_on', { default: 'turn on' }),
				)}</Text
			>
		</svelte:fragment>
	</ControlsContainer>
</div>
